// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--274sv","container":"footer-module--container--1oXSM","copyname":"footer-module--copyname--1KAPx"};